module.exports = __webpack_public_path__ + "img/Background_light_blue.66be6761.png";